// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"tV","backgroundimage":"uV","header":"vV","headerwrap":"wV","title":"xV","promomessage":"yV","upsellItem":"zV","upsellImg":"AV","helperText":"BV","upsellHeadline":"CV","price":"EV","upsellGross":"FV","upsellNet":"GV","upsellButton":"HV","nutritionfacts":"IV","nutritionimg":"JV","containerwhy":"KV","nutritionwrappwer":"LV","headlinewhy":"MV","boxwhy":"NV","textwhy":"OV","backbutton":"PV","drawercontainer":"QV","logoheader":"RV","textwrap":"SV","timer":"TV"};
    if(module.hot) {
      // 1726593108051
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  